import { Component, OnInit } from '@angular/core';
import { HttpApiService } from '../../../_services/http-api.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MessageService, PrimeIcons } from 'primeng/api';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-record-dialog',
  templateUrl: './record-dialog.component.html',
  styleUrls: ['./record-dialog.component.scss']
})
export class RecordDialogComponent implements OnInit {

  cols: any[];

  signData: any[]//接資料的表格變數

  constructor(
    private HttpApi: HttpApiService,
    private route: ActivatedRoute,
    private router: Router,
    private messageService: MessageService,
    public config: DynamicDialogConfig,
  ) {
    this.cols = [
      { field: 'topic', header: '階段' },
      { field: 'ApprovalMan', subfield: 'eng_name', header: '簽核人員' },
      { field: 'feedback', header: '回覆意見' },
      // { field: 'type', header: '類別' },
      { field: 'approval_at', header: '簽核時間', type: 'date' },
    ];

  }

  ngOnInit(): void {
    // this.getSign(1, 1000)

    console.log(this.config)

    this.signData = this.config.data.DocumentApproval
    this.eventConvert(this.config.data.DocumentApproval)

  }

  eventData: any = []
  eventConvert(event: any) {

    console.log(event)

    for (let i in event) {

      switch (event[i].status) {
        case 0:
          event[i].color = 'skyblue'
          // event[i].icon = 'pi pi-fw pi-times'
          break;

        case 1: case 3:
          event[i].color = 'yellowgreen'
          event[i].icon = 'pi pi-fw pi-check'
          break;

        case 2:
          event[i].color = 'lightpink'
          event[i].icon = 'pi pi-fw pi-times'
          break;

        case 4:
          event[i].color = 'yellowgreen'
          event[i].icon = 'pi pi-fw pi-angle-double-down'
          break;

        case 5: // 重審
          event[i].color = 'yellowgreen'
          event[i].icon = 'pi pi-fw pi-refresh'
          break;

        default:
          // event[i].color = 'skyblue'
          event[i].color = 'lavender'
          // event[i].icon = 'pi pi-fw pi-check'
          break;
      }

      this.eventData.push({
        no: i,
        status: event[i].topic,
        date: event[i].approval_at,
        content: event[i].feedback,
        color: event[i].color,
        icon: event[i].icon,
        approval_man: event[i].ApprovalMan.eng_name,
        type: event[i].type,
        remark: event[i].remark,
        has_rejected_order: event[i].has_rejected_order,
        remarked_at: event[i].remarked_at
      })


    }

    console.log(this.eventData)

  }

  openDel(type: string, remark: string) {

    let url
    switch (type) {

      case 'order':
        url = this.router.serializeUrl(this.router.createUrlTree([`main/sign/del/pi-sp/${remark}`]));
        window.open(url)
        break;
      case 'purchase-order':
        url = this.router.serializeUrl(this.router.createUrlTree([`main/sign/del/po/${remark}`]));
        window.open(url)
        break;
    }

  }

}
